<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="extra-large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form class="mb-0" ref="form" data-url="/organizations/otherLocations">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Nombre</label>
              <app-input
                type="text"
                v-model="inputs.org.name"
                placeholder="Ingrese su nombre"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Responsable</label>
              <app-input
                type="text"
                v-model="inputs.org.legal_representative"
                placeholder="Ingrese el responsable"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>País</label>
              <app-input
                type="select"
                v-model="inputs.org.country_id"
                :required="true"
                :list="[
                  { id: '', value: this.$t('select_option') },
                  ...this.$store.state.common.countries,
                ]"
              />
            </div>
          </div>

          <div
            class="col-md-6"
            v-if="inputs.org.country_id && provinceList.length <= 1"
          >
            <div class="form-group">
              <label>Ciudad</label>
              <app-input
                type="text"
                v-model="inputs.org.city"
                placeholder="Ingrese la ciudad"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="provinceList.length > 1">
            <div class="form-group">
              <label>Provincia</label>
              <app-input
                type="select"
                v-model="inputs.org.province_id"
                :required="true"
                :list="[
                  { id: '', value: this.$t('select_option') },
                  ...provinceList,
                ]"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="provinceList.length > 1">
            <div class="form-group">
              <label>Ciudad</label>
              <app-input
                type="select"
                v-model="inputs.org.canton_id"
                :required="true"
                :list="[
                  { id: '', value: this.$t('select_option') },
                  ...cantonList,
                ]"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Dirección</label>
              <app-input
                type="textarea"
                v-model="inputs.org.address"
                :required="true"
                placeholder="Ingrese la dirección"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Teléfono</label>
              <app-input
                type="tel-input"
                v-model="inputs.org.phone"
                placeholder="Ingrese su numero de telefono"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Ubicación subcontratada, prestada u otra</label>
              <app-input
                type="text"
                v-model="inputs.org.location"
                placeholder="Ingrese la ubicación subcontratada, prestada u otra"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">Tipo de Prueba (teórica, práctica u otra)</th>
                  <th scope="col">Categoría de personal a examinar</th>
                  <th scope="col" class="text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="addElement()"
                    >
                      <app-icon name="plus" />
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, index) in inputs.type_tests" :key="index">
                  <td>
                    <app-input
                      type="text"
                      v-model="value.type"
                      placeholder="Ingrese el tipo de prueba"
                      :required="true"
                    />
                  </td>
                  <td>
                    <!-- <app-input
                      type="text"
                      v-model="value.category"
                      placeholder="Ingrese la categoría de personal a examinar"
                      :required="true"
                    /> -->
                    <app-input
                      type="select"
                      v-model="value.category"
                      :required="true"
                      :list="categoryList"
                    />
                  </td>
                  <td class="text-center">
                    <button
                      type="submit"
                      class="btn btn-danger"
                      @click.prevent="deleteElement(index)"
                    >
                      <app-icon name="trash-2" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        @click.prevent="submit"
        :disabled="disabledSubmit"
      >
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    selectedUrl: String,
    activity: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {
        org: {},
        type_tests: [{ id: null, org_id: null, type: "", activity: "" }],
      },
      modalId: "add-edit-modal",
      provinceList: [],
      cantonList: [],
      categoryList: [
        { id: null, value: this.$t("select_option") },
        { id: "AI", value: "Certificación Inicial" },
        { id: "AM", value: "Ampliación de la certificación" },
        { id: "RE", value: "Renovación de la certificación" },
      ],
      disabledSubmit: false,
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? "Editar" : "Registrar";
    },
  },
  watch: {
    "inputs.org.country_id": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.org.country_id
      );
    },

    "inputs.org.province_id": function () {
      this.cantonList = this.$store.getters.getCantons(
        this.inputs.org.province_id
      );
    },

    "$store.state.common.countries": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.org.country_id
      );
      this.cantonList = this.$store.getters.getCantons(
        this.inputs.org.province_id
      );
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.inputs.org.acc_app_id = this.$store.state.accreditation.id;
      this.inputs.org.establishment_type = "OL";
      this.disabledSubmit = true;
      this.save(this.inputs);
    },

    afterJsValidationFail() {
      this.disabledSubmit = false;
    },

    afterSuccess(response) {
      // this.$toastr.s(response.data.message);
      if (this.inputs.id) {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs.org = response.data;
      this.inputs.type_tests = response.data.type_tests;
      this.preloader = false;
    },

    addElement() {
      this.inputs.type_tests.push({
        id: null,
        org_id: null,
        type: "",
        activity: "",
      });
    },

    deleteElement(index) {
      const tmp = this.inputs.type_tests.filter((item, i) => index != i);
      this.$set(this.inputs, "type_tests", tmp);
    },
  },
};
</script>
